import { useEffect, useState } from 'react'

import { Button } from '@/components/ui/button'

import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import PhotoCapture, { CapturedData } from './photo-capture'
import { useAddSignatureUser, useCreateSignatureUser, useFetchSignatureByIdUser } from '@/features/signatures/services'
import { useCurrentUser } from '@/features/auth/state/auth'

import SignaturePad from './SignaturePad'
import { FeedbackDialog } from '../../../components/form/feedback-dialog'
import { Loader2 } from 'lucide-react'

const UserAssinaturaButton = () => {
  const user = useCurrentUser()

  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [isDialogOpen2, setIsDialogOpen2] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isPhotoCaptureComplete, setIsPhotoCaptureComplete] = useState(false)
  const [showButton, setShowButton] = useState(false)

  const { data: signatureStatus } = user?.id ? useFetchSignatureByIdUser(user?.id) : { data: null }

  const { mutate: createSignature } = useCreateSignatureUser()
  const { mutate: addSignature } = useAddSignatureUser()
  const [, setSignature] = useState<File | null>(null)

  const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null)

  useEffect(() => {
    if (signatureStatus?.data) {
      setShowButton(signatureStatus?.data?.isModifica === true)
    }
  }, [signatureStatus])

  const handlePhotoCaptureComplete = async (data: CapturedData) => {
    setIsLoading(true)

    try {
      await new Promise<void>((resolve, reject) => {
        createSignature(
          {
            fotoPessoa: data.fotoPessoa,
            fotoDoc: data.fotoDoc,
            local: data.local,
            maquina: data.maquina
          },
          {
            onSuccess: () => {
              setMessage({
                type: 'success',
                text: 'Foto capturada e informações salvas!'
              })
              setIsPhotoCaptureComplete(true) // Move para o próximo passo
              setIsDialogOpen2(true)
              resolve()
            },
            onError: error => {
              console.error('Erro ao salvar informações:', error)
              setMessage({
                type: 'error',
                text: 'Falha ao salvar informações.'
              })
              setIsDialogOpen2(true)
              reject(error)
            }
          }
        )
      })
    } catch (error) {
      console.error('Erro durante o processo:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleSignatureComplete = async (signatureData: File) => {
    setSignature(signatureData)
    setIsLoading(true)
    try {
      await new Promise<void>((resolve, reject) => {
        if (user?.id) {
          addSignature(
            {
              cpf: signatureStatus?.data?.cpf,
              assinatura: signatureData
            },
            {
              onSuccess: () => {
                setMessage({
                  type: 'success',
                  text: 'Assinatura adicionada com sucesso!'
                })
                setIsDialogOpen2(true)
                resolve()
              },
              onError: error => {
                console.error('Erro ao adicionar assinatura:', error)
                setMessage({
                  type: 'error',
                  text: 'Falha ao adicionar assinatura.'
                })
                setIsDialogOpen2(true)
                reject(error)
              },
              onSettled: () => {
                setIsLoading(false)
              }
            }
          )
        }
      })
    } catch (error) {
      console.error('Erro durante o processo:', error)
    } finally {
      setIsLoading(false) // Desativar carregamento
    }
  }

  return (
    <>
      {showButton && (
        <Button
          onClick={() => setIsDialogOpen(true)}
          className="px-4 py-2  bg-primary hover:bg-primary-hover text-primary-foreground"
        >
          Assinar
        </Button>
      )}
      <FeedbackDialog isOpen={isDialogOpen2} onOpenChange={setIsDialogOpen2} message={message} />
      {isLoading && (
        <div className="absolute inset-0 bg-white/70 flex flex-col items-center justify-center z-50">
          <Loader2 className="h-12 w-12 animate-spin text-primary" />
          <span className="mt-2 text-lg font-semibold">Carregando...</span>
        </div>
      )}
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent className="max-h-screen max-w-screen-sm overflow-y-auto p-6">
          <DialogTitle>Assinatura</DialogTitle>
          <div className="flex flex-col items-center">
            {isPhotoCaptureComplete ? (
              <SignaturePad id_user={user?.id || 'default_id'} onComplete={handleSignatureComplete} />
            ) : (
              <PhotoCapture onComplete={handlePhotoCaptureComplete} />
            )}
          </div>
          {isLoading && (
            <div className="absolute inset-0 bg-white/70 flex flex-col items-center justify-center z-50">
              <Loader2 className="h-12 w-12 animate-spin text-primary" />
              <span className="mt-2 text-lg font-semibold">Carregando...</span>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  )
}
export default UserAssinaturaButton
